import {
  StyledCollapsible
} from "./chunk-FV4XTPDS.mjs";

// src/components/collapsible/collapsible-root.tsx
import React, { forwardRef } from "react";
var CollapsibleRoot = forwardRef(
  function CollapsibleRoot2(props, ref) {
    return /* @__PURE__ */ React.createElement(StyledCollapsible, { ...props, ref });
  }
);

export {
  CollapsibleRoot
};
